import React from 'react';

const PhotoSpace = () => {
    return (
        <div className="PhotoSpace">
            <img className="PhotoSpace__photo" src={process.env.PUBLIC_URL + "/martin.jpg"} alt="Martin_Ortega.jpg"></img>
        </div>
    )
}

const AboutText = () => {
    return (
        <div className="AboutText">
            <p className="AboutText__text">
                I am a web developer from Guatemala, that place right below Mexico, but not Mexico. I'm currently getting a degree in Computer Science and Information Technology. 
            </p>
            <p className="AboutText__text">
            Why? Well, since I was a boy I was always surrounded by computers and games, and my curiosity and love for computers got me to the point where I wanted to create things in a computer environment, be it programs or computer games.
            </p>
            <p className="AboutText__text">
                I found my calling in web development, where I could create useful software that people can access and look at from anywhere in the world. 
            </p>
            <p className="AboutText__text">
            Nowadays, I'm motivated by the concept of growth. I want to grow, as a developer and as a person. I am eager to learn about the world and everything that surrounds it. I wish to eventually be able to travel all over the world and discover new things that can help me out in my everyday life and in my work. 
            </p>
            <p className="AboutText__text">
                As a developer, I want to become a knowledgeable senior who can create more complex and faster products to satisfy clients with big dreams and aspirations and be able to write history.
            </p>
        </div>
    )
} 

const About = () => {
    return(
        <div className ="About">
            <center>
                <h2 className="AboutTitle">About</h2>
                <PhotoSpace></PhotoSpace>
                <AboutText></AboutText>
            </center>
        </div>
    )   
}

export default About;